import { Modal, notification } from 'antd'
import React, { useEffect, useState } from 'react'

const PreferredBrowserToast = () => {
    const [api, contextHolder] = notification.useNotification();

    const isSafari = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('safari') &&
            !userAgent.includes('chrome') &&
            !userAgent.includes('android') &&
            userAgent.includes('apple')
    };

    const openNotification = () => {
        api.open({
            message: 'Optimize Your Experience',
            description: 'Chrome is the preferred browser to use the script editor on mobile',
            placement: 'topRight',
            duration: 0,
            style: {
                width: 300,
            },
            onClose: () => {
                localStorage.setItem('hasShownPreferredModal', 'true')
            },
            btn: (
                <button
                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded"
                    onClick={(e) => {
                        e.stopPropagation();
                        localStorage.setItem('hasShownPreferredModal', 'true')
                        api.destroy();
                    }}
                >
                    Close
                </button>
            ),
        });
    };

    const showPreferredBrowserToast = () => {
        const hasShown = localStorage.getItem('hasShownPreferredModal')
        if (hasShown) {
            return
        }
        if (isSafari()) {
            openNotification()
        }
    }

    useEffect(() => {
        showPreferredBrowserToast()
    }, [])

    return (
        <div>
            {contextHolder}
        </div>
    )
}

export default PreferredBrowserToast